export const BLUE_ALERT = "primary";
export const GRAY_ALERT = "secondary";
export const GREEN_ALERT = "success";
export const RED_ALERT = "danger";
export const YELLOW_ALERT = "warning";
export const INDIGO_ALERT = "info";
export const LIGHT_ALERT = "light";
export const DARK_ALERT = "dark";
